
const mutationObserver = () => {
  let observer = null;

  const observe = (targetNode, config, callbackFunction) => {
    if (targetNode && callbackFunction) {
      observer = new MutationObserver(callbackFunction);

      observer.observe(targetNode, config);
    }
  };

  const disconnect = () => {
    observer.disconnect();
  };

  return { observe, disconnect };
};

export default mutationObserver;
